<template>

  <div-box>
    <wallet-head show_type="10" />
    <div-padding padding="3vw 4vw 10vw">
      <van-swipe class="swipebox" autoplay="4000" indicator-color="#FD7F1F">
        <van-swipe-item v-for="(item, index) in banner" :key="index">
          <img :src="item.img[0].url" alt="">
        </van-swipe-item>
      </van-swipe>
      <router-link to="mlist" class="tit">
        <div class="l">{{ $t('我的矿机') }}</div>
        <div class="r">></div>
      </router-link>

      <!-- <div class="numbox">
        <div class="num">
          <div class="l">
            <p>{{ $t('已购买矿机') }}</p>
            <p class="n">5<span>{{ $t('台') }}</span></p>
          </div>
          <van-button size="mini" round color=" linear-gradient( 90deg, #EBC699 0%, #CD823A 100%)" @click="submit">{{
            $t('开始挖矿') }}</van-button>
        </div>
        <div class="nbox">
          <p>{{ $t('进度') }}：55%</p>
          <van-progress color="#EBC699" :percentage="50" stroke-width="8" />
        </div>
      </div>
      <router-link to="" class="tit">
        <div class="l">{{ $t('动态分红') }}</div>
        <div class="r">{{ $t('查看更多') }}></div>
      </router-link>
      <div class="item">
        <div class="l">
          <p>动态奖</p>
          <p>2020-08-10 00:00:10</p>
        </div>
        <div class="n">10.00</div>
      </div>
      <router-link to="" class="tit">
        <div class="l">{{ $t('领导分红') }}</div>
        <div class="r">{{ $t('查看更多') }}></div>
      </router-link>
      <div class="item">
        <div class="l">
          <p>动态奖</p>
          <p>2020-08-10 00:00:10</p>
        </div>
        <div class="n">10.00</div>
      </div> -->
      <!-- <div class="msg">
        <img src="@/assets/img/zhuyi_icon@2x.png" alt="">{{ $t('矿机说明') }}
      </div>
      <div class="content">点击开始挖矿后，按钮显示挖矿中</div> -->
    </div-padding>

    <van-popup v-model="show" style="width: 80%;" :close-on-click-overlay="false">
      <div class="popupbox">
        <div class="body">
          <div class="ti">{{ $t('提示') }}</div>
          <div class="content">
            <p>{{ $t('请先购买矿机') }}</p>
            <div>
              <span @click="show = false">{{ $t('取消') }}</span>
              <router-link to="mshop">{{ $t('矿机商城') }}</router-link>
            </div>
          </div>
        </div>
        <img src="@/assets/img/guanbi@2x.png" alt="" @click="show = false">
      </div>
    </van-popup>
  </div-box>
</template>
<script>
  export default {
    data() {
      return {
        banner: [],
        show: false,
      }
    },
    created() {
      this.getdatas()
    },
    methods: {
      getdatas() {
        this.$get({
          url: "/api/v1/banner",
          success: (res) => {
            this.banner = res.data
          },
          tip: () => { },
        })
      },
      submit() {
      },
    },
  }
</script>
<style lang='less' scoped>
  .swipebox {
    width: 100%;
    height: 32vw;
    border-radius: 6px;
    overflow: hidden;
    /deep/.van-swipe-item {
      width: 100%;
      height: 100%;
      >img,
      >video {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .numbox {
    width: 100%;
    margin: 0 0 5px;
    background: url('../../../assets/img/bg@x.png') no-repeat;
    background-size: 100% 100%;
    padding: 24px 20px;
    .num {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .l {
        width: 70%;
        p {
          width: 100%;
          color: #FFFFFF;
          font-size: 12px;
        }
        .n {
          width: 100%;
          color: #E6B17F;
          font-size: 24px;
          font-weight: 550;
          margin-top: 5px;
          span {
            font-size: 20px;
          }
        }
      }
      /deep/.van-button {
        width: 80px;
        height: 28px;
        .van-button__text {
          font-size: 12px;
          color: #fff;
        }
      }
    }
    .nbox {
      width: 100%;
      padding: 20px 0 0;
      >p {
        width: 100%;
        color: #fff;
        font-size: 12px;
        margin-bottom: 10px;
      }
    }
  }
  .tit {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 2px;
    color: #fff;
    margin-bottom: 10px;
    .l {
      font-size: 18px;
      font-weight: 550;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 47px;
        height: 4px;
        background: linear-gradient(270deg, rgba(40, 40, 40, 0.29) 0%, #E6B17F 100%);
        border-radius: 2px;
      }
    }
    .r {
      font-size: 13px;
    }
  }
  .item {
    width: 100%;
    background: #1A1C1D;
    border-radius: 4px;
    margin-bottom: 15px;
    padding: 14px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .l {
      width: 60%;
      p {
        font-size: 12px;
        color: #D8D8D8;
        &:nth-child(1) {
          color: #fff;
          font-size: 14px;
          margin-bottom: 3px;
        }
      }
    }
    .n {
      width: 39%;
      text-align: right;
      color: #E6B17F;
      font-size: 16px;
      font-weight: 550;
    }
  }
  .msg {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img {
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }
    color: #666666;
    font-size:14px;
  }
  .content {
    width: 100%;
    padding: 10px 0;
    color: #666666;
    font-size: 14px;
  }
  /deep/.van-popup {
    background: none;
    .popupbox {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .body {
        width: 100%;
        background: #fff;
        border-radius: 12px;
        overflow: hidden;
        margin-bottom: 20px;
        .ti {
          width: 100%;
          background: linear-gradient(90deg, #EBC699 0%, #CD823A 100%);
          padding: 11px 0;
          color: #fff;
          font-size: 18px;
          text-align: center;
        }
        .content {
          width: 100%;
          padding: 25px 20px 48px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          >p {
            color: #333333;
            font-size: 14px;
            margin-bottom: 35px;
          }
          >div {
            width: 100%;
            padding: 0 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            span,
            a {
              width: 45%;
              height: 36px;
              background: #C7C7CC;
              border-radius: 20px;
              text-align: center;
              line-height: 36px;
              color: #FFFFFF;
              font-size: 14px;
            }
            a {
              background: linear-gradient(90deg, #EBC699 0%, #CD823A 100%);
            }
          }
        }
      }
      img {
        width: 50px;
        height: 50px;
      }
    }
  }
</style>